import request from '@/utils/request'

//结算列表
export function getList(data) {
    return request({
        url: '/backend/psy/settlement/list',
        method: 'post',
        data: data
    })
}

//查看咨询日志列表
export function showCounselLogList(data) {
    return request({
        url: '/backend/psy/settlement/counsel-log-list',
        method: 'post',
        data: data
    })
}

//查看咨询日志详情
export function showCounselLogInfo(data) {
    return request({
        url: '/backend/psy/settlement/counsel-log-info',
        method: 'post',
        data: data
    })
}

//结算审核列表
export function getVerifyList(data) {
    return request({
        url: '/backend/psy/settlement/verify-list',
        method: 'post',
        data: data
    })
}

//审核
export function verify(data) {
    return request({
        url: '/backend/psy/settlement/verify',
        method: 'post',
        data: data
    })
}

//审核记录
export function getVerifyRecord(data) {
    return request({
        url: '/backend/psy/settlement/verify-record',
        method: 'post',
        data: data
    })
}

